import { map } from 'lodash'

const prepareSave = (covenant) => {
  covenant.plans = map(covenant.plans, plan => {
    return {
      covenant_plan_id: plan.id
    }
  })

  if (covenant.plans.lenght === 0) {
    delete covenant.plans
  }

  return covenant
}

export default {
  afterSave (covenant, oldCovenant) {
    this.saved = true
  },
  prepareSave (covenant) {
    return prepareSave(covenant)
  },
  setPlansFromCovenant (covenant) {
    if (covenant) {
      this.plans = covenant.active_plans
    }
  },
  afterCreated () {
    this.show = true
    this.wasRaised = true
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/company/covenants/create/resources/methods.js